__webpack_require__.p = "https://festatic.playgami.scopely.com/portal-host/39427999323/";